import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import DrawerForm from "components/form";
import { bindActionCreators, Dispatch } from "redux";
import { Creators as AttendanceActions } from "store/attendance/attendance-duck";
import { Creators as LobbyActions } from "store/lobby/lobby-duck";
import { IRegisterActiveItem, IProcessesData, IDocumentsData, ISaleChannelData, IDocumentType, PlateFormatType } from "store/lobby/lobby-model";
import { DrawerStatusEnum } from "typings/global.types";
import { mountRegisterFormValues } from "utils/form/saleChannel";

interface IPropsScreenViewRegister {
  form?: any;
  inboundProcessesList: IProcessesData[];
  salesChannelList?: ISaleChannelData[];
  documentsList: IDocumentsData[];
  isLoading?: boolean;
  drawerIsLoading?: boolean;
  registerActive?: IRegisterActiveItem;
  hasSaleChannel: boolean;
  visibleDrawerViewMode: DrawerStatusEnum;
  visibleDrawerViewRegisterAttendance: boolean;
  documentType: IDocumentType;
  plateFormatType?: PlateFormatType;
  saleChannelActive?: number;
}

interface IDispatchProps {
  lobbyDocumentsFetchAsync?: (...args) => void;
  attendanceUpdateFormModified?: (...args) => void;
  lobbyProcessActive: (...args) => void;
  lobbySaleChannelActive: (...args) => void;
  lobbyUpdateEntryPermissionActive?: (...args) => void;
  lobbyUpdateStepEntryPermissionStatus?: (...args) => void;
  lobbyFetchEntryPermissionAsync?: (...args) => void;
}

export type IPropsViewRegister = IPropsScreenViewRegister & IDispatchProps;

export const ViewRegister = ({
  form,
  registerActive,
  hasSaleChannel,
  drawerIsLoading,
  documentType,
  visibleDrawerViewMode,
  visibleDrawerViewRegisterAttendance,
  inboundProcessesList,
  documentsList,
  salesChannelList,
  plateFormatType,
  saleChannelActive,
  attendanceUpdateFormModified,
  lobbyUpdateEntryPermissionActive,
  lobbyFetchEntryPermissionAsync,
  lobbyUpdateStepEntryPermissionStatus,
  lobbySaleChannelActive,
  lobbyProcessActive,
  lobbyDocumentsFetchAsync,
}: IPropsViewRegister) => {
  useEffect(() => {
    if (registerActive?.id) {
      form.setFieldsValue(mountRegisterFormValues(registerActive, hasSaleChannel, salesChannelList, visibleDrawerViewMode === DrawerStatusEnum.Edit));
    }
  }, [registerActive, hasSaleChannel, salesChannelList, visibleDrawerViewMode]);

  return (
    <Form.Provider
      onFormChange={(_, info) => {
        const { changedFields } = info;
        const changedFileldsSize = changedFields?.length || 0;
        if (changedFileldsSize === 1) {
          attendanceUpdateFormModified(true);
        }
      }}
    >
      <DrawerForm
        form={form}
        disabledFields={visibleDrawerViewMode === DrawerStatusEnum.View}
        documentsList={documentsList}
        lobbyDocumentsFetchAsync={lobbyDocumentsFetchAsync}
        registerActive={registerActive}
        carrierRef={null}
        lobbyProcessActive={lobbyProcessActive}
        inboundProcessesList={inboundProcessesList}
        hasSaleChannel={hasSaleChannel}
        lobbySaleChannelActive={lobbySaleChannelActive}
        salesChannelList={salesChannelList}
        visibleDrawerView={visibleDrawerViewRegisterAttendance}
        visibleDrawerAddNewRegister={false}
        disabledPlate={true}
        visibleDrawerViewMode={visibleDrawerViewMode}
        drawerIsLoading={drawerIsLoading}
        documentType={documentType}
        hasEntryPermission={false}
        plateFormatType={plateFormatType}
        lobbyFetchEntryPermissionAsync={lobbyFetchEntryPermissionAsync}
        lobbyUpdateEntryPermissionActive={lobbyUpdateEntryPermissionActive}
        lobbyUpdateStepEntryPermissionStatus={lobbyUpdateStepEntryPermissionStatus}
        saleChannelActive={saleChannelActive}
      />
    </Form.Provider>
  );
};

const mapDispatchToActions = (dispatch: Dispatch) => bindActionCreators({ ...LobbyActions, ...AttendanceActions }, dispatch);

const mapStateToProps = (state) => ({
  isLoading: state.Attendance.isLoading,
  visibleDrawerViewMode: state.Attendance.visibleDrawerViewMode,
  visibleDrawerViewRegisterAttendance: state.Attendance.visibleDrawerViewRegisterAttendance,
  registerActive: state.Lobby.registerActive,
  hasSaleChannel: state.Lobby.hasSaleChannel,
  salesChannelList: state.Lobby.salesChannelList,
  inboundProcessesList: state.Lobby.inboundProcessesList,
  documentsList: state.Lobby.documentsList,
  drawerIsLoading: state.Lobby.drawerIsLoading,
  documentType: state.Lobby.documentType,
  plateFormatType: state.Lobby.plateFormatType,
  saleChannelActive: state.Lobby.saleChannelActive,
  processActive: state.Lobby.processActive,
});

export default connect(mapStateToProps, mapDispatchToActions)(ViewRegister);
